<template>
  <portal to="modal">
    <transition v-if="downloading" name="fade" mode="out-in">
      <div class="download-bar">
        <div class="download-bar__icon">
          <vs-icon
            :icon="downloading ? 'cloud_download' : 'check_circle'"
            size="medium"
          />
        </div>
        <div class="download-bar__content">
          <span>
            {{ downloading ? "Downloading..." : "Downloaded" }}
          </span>
          <div class="download-bar__progress">
            <div
              class="download-bar__progress-bar"
              :style="{ width: `${progress}%` }"
            >
              <span class="sr-only">Download progress</span>
            </div>
          </div>
        </div>
        <!-- <button
          v-if="progress === 100"
          class="download-bar__close-btn"
          @click="$emit('close')"
        >
          <vs-icon icon="close" size="small" />
        </button> -->
      </div>
    </transition>
  </portal>
</template>

<script>
export default {
  name: "DownloadBar",
  props: {
    title: {
      type: String,
      default: "",
    },
    isDownloading: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    downloading() {
      return this.isDownloading;
    },
  },
};
</script>
<style lang="scss" scoped>
.download-bar {
  right: 2.3rem;
  top: 9vh;
  z-index: 100;
  @apply flex items-center fixed shadow-lg rounded bg-white max-w-sm w-full px-4 py-3;
  &__icon {
    @apply w-12;
    i {
      @apply text-blue;
    }
  }
  &__content {
    @apply flex flex-col flex-1 px-4 py-2;
    span {
      @apply text-sm block mb-2;
    }
  }
  &__progress {
    @apply w-full h-1 relative mt-1 rounded bg-grey-light;
    &-bar {
      @apply h-full absolute left-0 top-0 bg-blue rounded transition-all duration-300;
    }
  }
  &__close-btn {
    top: 18px;
    right: 20px;
    @apply absolute w-8 h-8 inline-flex items-center justify-center rounded-full cursor-pointer border-none outline-none bg-grey-light;
  }
}
</style>
